import React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router'

import { ROUTES } from '../../../../../../constants/routes'
import { useGlobalSearch } from '../../../hooks/useGlobalSearch'

const NoResultsMessage: React.FC = () => {
  const globalSearch = useGlobalSearch()
  const { searchTerm } = globalSearch
  const navigate = useNavigate()

  return (
    <div className="d-flex flex-column align-items-center pb-1">
      <p className="text-xl text-center mb-1">
        <span>No results for </span>
        <span className="fw-semibold text-black break-word">
          "{searchTerm}"
        </span>
      </p>

      <div>
        <Button
          variant="link p-0"
          onClick={() => {
            globalSearch.hide()
            navigate(ROUTES.addContact({ searchParams: { name: searchTerm } }))
          }}
        >
          Add contact with the name "{searchTerm}
        </Button>
      </div>
    </div>
  )
}

export default NoResultsMessage
